import React, { Fragment } from "react";
import TextField from "../../common/TextField";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import { FormHelperText } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import InfoIcon from "@mui/icons-material/Info";
import SingleSelect from "../../common/SingleSelect";
import { checkPrivileges } from "../../../Helpers";
import {
  PasswordRequirements,
  WhiteTooltip,
  ValidationIcon,
} from "./FormHelpers";

const UserIdentitySection = (props) => (
  <Fragment>
                  <h4>{props.translate("userDetail")}</h4>
                  <Grid container spacing={2}>
                    <Grid item md={3} sm={6} xs={12}>
                      <TextField
                        id="name"
                        // error={props.nameInvalidError}
                        label={props.translate("sharedName")}
                        type="text"
                        placeholder=""
                        value={props.form.name}
                        onChange={props.handleChange("name")}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        required
                        error={Boolean(props.addUserFieldErrors?.name)}
                      />
                      {/* <FormHelperText error={props.nameInvalidError ? true : false}>
                                  Special Characters not allowed in  Name
                              </FormHelperText> */}
                    </Grid>
                    <Grid item md={3} sm={6} xs={12}>
                      <TextField
                        id="email"
                        error={
                          props.duplicateEntry ||
                          props.emailInvalidError ||
                          Boolean(props.addUserFieldErrors?.email)
                        }
                        label={props.translate("userEmail")}
                        type="email"
                        placeholder=""
                        value={props.form.email}
                        onChange={props.handleChange("email")}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        required
                      />
                      <FormHelperText
                        error={
                          Boolean(props.emailInvalidError) ||
                          Boolean(props.addUserFieldErrors?.email)
                        }
                      >
                        {props.translate(
                          "Please enter a valid email address",
                        )}
                      </FormHelperText>
                    </Grid>
                    {!props.editOption && (
                      <>
                        <Grid item md={3} sm={6} xs={12}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div style={{ width: "96%" }}>
                              <TextField
                                id="password"
                                label={props.translate("userPassword")}
                                type={
                                  props.showPassword ? "text" : "password"
                                }
                                placeholder=""
                                value={props.form.password}
                                onChange={props.handleChange("password")}
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                required
                                error={Boolean(
                                  props.addUserFieldErrors?.password,
                                )}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          marginTop: "3px",
                                        }}
                                        onClick={props.handleTogglePassword}
                                      >
                                        {props.showPassword ? (
                                          <VisibilityOffOutlinedIcon
                                            style={{
                                              color:
                                                props.themecolors?.menuActiveBackground,
                                            }}
                                          />
                                        ) : (
                                          <VisibilityOutlinedIcon
                                            style={{
                                              color:
                                                props.themecolors?.menuActiveBackground,
                                            }}
                                          />
                                        )}
                                      </div>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>

                            <WhiteTooltip
                              title={
                                <div>
                                  <PasswordRequirements
                                    hasLengthValid={props.hasLengthValid}
                                    hasNumberValid={props.hasNumberValid}
                                    hasUpperCaseValid={
                                      props.hasUpperCaseValid
                                    }
                                    hasLowerCaseValid={
                                      props.hasLowerCaseValid
                                    }
                                    hasSpecialCharValid={
                                      props.hasSpecialCharValid
                                    }
                                    translate={props.translate}
                                  />
                                </div>
                              }
                              arrow
                              PopperProps={{
                                modifiers: [
                                  {
                                    name: "preventOverflow",
                                    options: {
                                      boundary: "window",
                                    },
                                  },
                                ],
                              }}
                            >
                              <InfoIcon
                                fontSize="large"
                                style={{
                                  fontSize: 24,
                                  color: "grey",
                                  marginLeft: "5px",
                                  cursor: "pointer",
                                }}
                              />
                            </WhiteTooltip>
                          </div>
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="confirmPassword"
                            label={props.translate("confirmPassword")}
                            type={
                              props.showConfirmPassword
                                ? "text"
                                : "password"
                            }
                            error={
                              Boolean(
                                props.addUserFieldErrors?.confirmPassword,
                              ) || !props.isConfirmPassChk
                            }
                            placeholder=""
                            value={props.form.confirmPassword}
                            onChange={props.handleChange(
                              "confirmPassword",
                            )}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            required
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      marginTop: "3px",
                                    }}
                                    onClick={props.handleToggleConfirmPassword}
                                  >
                                    {props.showConfirmPassword ? (
                                      <VisibilityOffOutlinedIcon
                                        style={{
                                          color:
                                            props.themecolors?.menuActiveBackground,
                                        }}
                                      />
                                    ) : (
                                      <VisibilityOutlinedIcon
                                        style={{
                                          color:
                                            props.themecolors?.menuActiveBackground,
                                        }}
                                      />
                                    )}
                                  </div>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <FormHelperText
                            style={{ color: props.themecolors.textColor }}
                          >
                            <ValidationIcon
                              isValid={props.isConfirmPassChk}
                              message={props.translate(
                                "Both Passwords must be Equal",
                              )}
                            />
                          </FormHelperText>
                        </Grid>
                        {/* {props.userType === -1 && ( */}
                        <>
                          <Grid
                            item
                            sm={6}
                            md={3}
                            xs={12}
                            style={{ zIndex: 99 }}
                          >
                            {/* {console.log(
                                ".accountSelectedData====",
                                props.accountSelectedData
                              )}
                              {console.log(
                                "defaultAccountsList====",
                                props.defaultAccountsList
                              )} */}

                            {/* <AsyncSelect
                                isMulti={false}
                                value={props.accountSelectedData}
                                {...props}
                                selectName="accountId"
                                placeholder={props.translate(
                                  "searchAccount"
                                )}
                                resultMessage={props.resultMessage}
                                defaultOptions={props.defaultAccountsList}
                                handleChange={props.timezone_handleChange}
                                loadOptions={props.searchAccountsList.bind()}
                              /> */}
                            <SingleSelect
                              array={props.defaultAccountsList || []}
                              async
                              selectName="accountId"
                              isClearable
                              loadOptions={props.searchAccountsList.bind()}
                              label={props.translate("searchAccount")}
                              value={
                                props.accountSelectedData &&
                                props.accountSelectedData.id
                                  ? {
                                      id: props.accountSelectedData.id,
                                      value: props.accountSelectedData.id,
                                      label:
                                        props.accountSelectedData.name,
                                    }
                                  : null
                              }
                              handleChange={props.timezone_handleChange}
                              canAssign={true}
                              menuPlacement="auto"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </Grid>

                          <Grid
                            item
                            sm={6}
                            md={3}
                            xs={12}
                            style={{ zIndex: 99 }}
                          >
                            <SingleSelect
                              array={props.defaultUsersList || []}
                              async
                              selectName="parentId"
                              isClearable
                              loadOptions={props.searchUsersList.bind()}
                              label={props.translate("searchUsers")}
                              value={
                                props.userSelectedData &&
                                props.userSelectedData.value
                                  ? {
                                      id: props.userSelectedData.value,
                                      value: props.userSelectedData.value,
                                      label: props.userSelectedData.label,
                                    }
                                  : "searchUsers"
                              }
                              handleChange={props.timezone_handleChange}
                              canAssign={true}
                              menuPlacement="auto"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                            {/* <AsyncSelect
                                isDisabled={
                                  props.loadingUser ? true : false
                                }
                                isMulti={false}
                                value={props.userSelectedData}
                                {...props}
                                selectName="parentId"
                                placeholder={props.translate(
                                  "searchUsers"
                                )}
                                resultMessage={props.resultMessage}
                                defaultOptions={props.defaultUsersList}
                                handleChange={props.timezone_handleChange}
                                loadOptions={props.searchUsersList.bind()}
                              /> */}
                          </Grid>
                        </>
                        {/* )} */}
                      </>
                    )}

                    <Grid item md={3} sm={6} xs={12}>
                      {/* <TextField
                        id="city"
                        label={props.translate("city")}
                        type="city"
                        placeholder=""
                        value={props.form.city || ""}
                        onChange={props.handleChange("city")}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                      /> */}
                      <SingleSelect
                        array={props?.cities || []}
                        async
                        isClearable
                        selectName="city"
                        label={props.translate("city")}
                        value={
                          props.citySelectedData &&
                          props.citySelectedData
                            ? {
                                id:
                                  props.citySelectedData.id ||
                                  props.citySelectedData,
                                value:
                                  props.citySelectedData.id ||
                                  props.citySelectedData,
                                label:
                                  props.citySelectedData.name ||
                                  props.citySelectedData.cityId,
                              }
                            : ""
                        }
                        handleChange={props.timezone_handleChange}
                        canRemove={true}
                        canAssign={true}
                      />
                    </Grid>
                    {/* {!props.editOption && (
                    <>
                      <Grid item md={3} sm={6} xs={12}>
                        <TextField
                          id='userType'
                          select
                          label={props.translate('userType')}
                          value={props.form.userType || ''}
                          onChange={props.handleChange('userType')}
                          SelectProps={{
                            MenuProps: {
                              className: props.classes.menu
                            }
                          }}
                          margin='dense'
                          fullWidth
                          // helperText={props.roleTypes.length ? <span onClick={props.toggleRoles} style={{cursor: 'pointer'}}><b>Select Custom Role</b></span> : ''}
                          required
                        >
                          <MenuItem value=''>
                            <em>{props.translate('none')}</em>
                          </MenuItem>
                          {props.userTypeArray.length &&
                            props.userTypeArray.map(option => (
                              <MenuItem key={option.key} value={option.key}>
                                {props.translate(option.name)}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    </>
                  )} */}
                    {!props.showButton && (props.roleTypes || []).length ? (
                      <Grid
                        item
                        md={3}
                        sm={6}
                        xs={12}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <span
                          onClick={(e) => props.toggleRoles(e)}
                          style={{ cursor: "pointer" }}
                        >
                          <b>{props.translate("selectCustomRole")}</b>
                        </span>
                      </Grid>
                    ) : (
                      ""
                    )}
                    {checkPrivileges("role") && props.showButton && (
                      <Grid item md={3} sm={6} xs={12}>
                        <TextField
                          id="role"
                          select
                          label={props.translate("role")}
                          value={props.form.roleId || ""}
                          onChange={props.handleChange("roleId")}
                          SelectProps={{
                            MenuProps: {
                              className: props.classes.menu,
                            },
                          }}
                          margin="dense"
                          fullWidth
                        >
                          {/* {!props.editOption && 
                                (<MenuItem key={'defaultRole'} value={'defaultRole'} >
                                  <em>{props.translate('default')}</em>
                                </MenuItem>
                                )}
                              {!props.editOption && <Divider style={{background:'black'}}/> } */}

                          {(props.roleTypes || []).length ? (
                            props.roleTypes.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {props.translate(option.name)}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem value="">
                              <em>{props.translate("none")}</em>
                            </MenuItem>
                          )}
                        </TextField>
                        {!props.editOption ? (
                          <span
                            onClick={(e) => props.toggleRoles(e)}
                            style={{ cursor: "pointer" }}
                          >
                            <b>Use Default Role</b>
                          </span>
                        ) : (
                          ""
                        )}
                      </Grid>
                    )}
                  </Grid>
  </Fragment>
);

export default UserIdentitySection;
